import type React from "react";
import {Typography} from "@mui/material";
import {useOutletContext} from "react-router";
import {CustomCard} from "~/components/Card/Card";
import type {SupplierDetailOutletContext} from "../types/Supplier360Types";

/** Shared empty-state body for a not-yet-built Supplier 360 tab. */
export const SupplierTabPlaceholder: React.FC<{title: string}> = ({title}) => {
    const {entity} = useOutletContext<SupplierDetailOutletContext>();

    return (
        <CustomCard title={title} subHeader={entity.canonical_name} sx={{mt: 2}}>
            <Typography variant="body2" color="text.secondary" sx={{mt: 1.5}}>
                {title} content coming soon.
            </Typography>
        </CustomCard>
    );
};
